/** Partnership theme: keep in sync with `style/root.css` :root variables. */
export const colors = {
    /** Selects `Auth/statics/bgLogin_${color}.svg` for login/signup hero art */
    color: "shift4",
    /** Inspiration Blue (Shift4 brand) */
    primary: "#136EF6",
    /** Space Black (Shift4 brand) — secondary UI text */
    secondary: "#090304",
    bgColor: "#f0f2f5",
    btnColor: "white",
    alertRed: "#fff5f5",
    alertGreen: "#f5fff6",
    alertYellow: "#fffbf5",
}
